import React from 'react';
import RealEstateManagingPartnerMarketing from './RealEstateManagingPartnerMarketing';

// Simplified Marketing - Always renders the Real Estate Managing Partner Marketing
const Marketing = () => {
  return <RealEstateManagingPartnerMarketing />;
};

export default Marketing;
